export default {
  call: 'getBusinessUsersReporting',
  businessid: 995,
  apiKey: 'd8810712-df40-11e4-9ccc-22000ac88c3a',
  startdate: '2020-07-16',
  enddate: '2020-07-29',
  timezone: 'America/Los_Angeles',
};
